<template>
  <div>
    <p
      v-if="!noBack"
      @click="back"
      class="d-table c-blue font-weight-bold cursor-pointer"
    >
      <span><v-icon class="c-blue">mdi-arrow-left-thin</v-icon></span>
      voltar
    </p>

    <p class="text-body-2 font-weight-bold py-8">
      Histórico de edições
    </p>

    <Loading v-if="loading_data" />

    <div v-else-if="tab === 0">
      <v-data-table
        :headers="headers"
        :items="data"
        :items-per-page="-1"
        item-key="id"
        hide-default-footer
        class="elevation-1"
        ><template v-slot:item.visualizar="{ item }">
          <v-btn
            elevation="2"
            color="primary"
            rounded
            small
            depressed
            @click.stop="handleClick(item)"
          >
            visualizar
          </v-btn>
        </template>
      </v-data-table>
    </div>

    <div v-else-if="tab === 1">
      <Loading v-if="loading_solution" />
      <div v-else>
        <div class="mt-n8 block">
          <p class="text-body-2 float-left">
            Versão de {{ selected.date }}, por {{ selected.user }}.
          </p>
          <v-btn
            :disabled="!showRestoreBtn || loading_restore"
            :loading="loading_restore"
            @click="handleRestore"
            rounded
            class="float-right text-lowercase mt-n8"
            color="primary"
            ><v-icon small class="mr-2">mdi-history</v-icon>voltar
            para essa versão</v-btn
          >
        </div>

        <PaasSolution :plan="solution" />
      </div>
    </div>
  </div>
</template>

<script>
import {
  getHistoryCenter,
  getHistoryPlan,
  getHistorySolutionCenter,
  getHistorySolutionPlan
} from "@/api/paas/history";
import { publicSolution } from "@/api/paas/center";
import { restoreSolutionPlan } from "@/api/paas/plans";
import Loading from "@/components/Loading.vue";
import PaasSolution from "@/components/paas/PaasSolution.vue";

export default {
  name: "HandleHistory",
  props: {
    plan: Number,
    noBack: Boolean,
    option: {
      type: Number,
      default: 0
    }
  },
  components: {
    Loading,
    PaasSolution
  },
  mounted() {
    this.init();
  },
  data() {
    return {
      tab: 0,
      loading_data: true,
      loading_solution: true,
      loading_restore: false,
      data: [],
      selected: {},
      showRestoreBtn: false,
      solution: {},
      headers: [
        { text: "Data", value: "date", align: "start" },
        { text: "Modificado por", value: "user" },
        { text: "", value: "visualizar", align: "end" }
      ]
    };
  },
  methods: {
    back() {
      if (this.tab != 0) return (this.tab = 0);
      this.$emit("back");
    },
    handleClick(_item) {
      this.showRestoreBtn = _item != this.data[0];
      this.selected = _item;
      this.handleOpenSolution();
    },
    init() {
      switch (this.option) {
        case 0:
          this.getData(getHistoryCenter);
          break;
        default:
          this.getData(getHistoryPlan, this.plan);
      }
    },
    handleOpenSolution() {
      switch (this.option) {
        case 0:
          this.getSolutionData(getHistorySolutionCenter);
          break;
        default:
          this.getSolutionData(getHistorySolutionPlan);
      }
    },
    getSolutionData(getFunction) {
      this.tab = 1;
      this.loading_solution = true;
      getFunction(this.selected.id)
        .then(_ => {
          console.log("res", _);
          this.solution = _;
        })
        .finally(() => {
          this.loading_solution = false;
        });
    },
    getData(getFunction, plan) {
      getFunction(plan)
        .then(_ => {
          this.data = _;
        })
        .finally(() => {
          this.loading_data = false;
        });
    },
    handleRestore() {
      switch (this.option) {
        case 0:
          this.restore(publicSolution);
          break;
        default:
          this.restore(restoreSolutionPlan);
      }
    },
    restore(restoreFunction) {
      this.loading_restore = true;
      restoreFunction(this.selected.id, this.plan)
        .then(() => {
          this.$router.go();
        })
        .catch(() => {
          alert("Erro ao restour versão.");
        })
        .finally(() => {
          this.loading_restore = false;
        });
    }
  }
};
</script>

<style scoped>
.c-blue {
  color: #0088ff;
}

.cursor-pointer {
  cursor: pointer;
}

.block {
  clear: both;
  display: table;
  width: 100%;
}
</style>
